/*********************************************************************
 * 
 * WARNING: This shader class is automatically generated, any manual 
 * edits will be lost.
 * Last generated: 2020-04-03T14:33:08.691Z
 * 
 ********************************************************************/
import { ShaderBase } from '../ShaderBase';

export type DecalShaderUniforms = {
	uModelViewMatrix: WebGLUniformLocation,
	uProjectionMatrix: WebGLUniformLocation,
	uBoneMatrix: WebGLUniformLocation,
	uOffsetMatrix: WebGLUniformLocation,
	uNormalMatrix: WebGLUniformLocation,
	uTextureSampler: WebGLUniformLocation,
	uBindShapeMatrix: WebGLUniformLocation,
	uInvBindShapeMatrix: WebGLUniformLocation,
	uMatrixSampler: WebGLUniformLocation,
	uDataSettings: WebGLUniformLocation,
	uPresetColor: WebGLUniformLocation,
	uColor: WebGLUniformLocation,
	uProjectedTextureSampler: WebGLUniformLocation
};

export type DecalShaderAttributes = {
	aVertexPosition: number,
	aVertexNormal: number,
	aVertexColor: number,
	aVertexLight: number,
	aTextureCoord: number,
	aJointWeights: number,
	aJointIndices: number
};

export type DecalShaderSettings = ('ATTACHMENT' | 'PICKING' | 'ATTRIBUTE_COLOR' | 'ATTRIBUTE_LIGHT' | 'TEXTURE' | 'ANIMATION' | 'PRESET_COLOR')[];

export class DecalShader extends ShaderBase<DecalShaderUniforms, DecalShaderAttributes> {

    private static fragmentShaderSource = `
// Passed in from the vertex shader.
varying vec2 vTextureCoord;
varying vec4 vProjectedTextureCoord;
 
uniform vec4 uColor;
uniform sampler2D uTextureSampler;
uniform sampler2D uProjectedTextureSampler;
 
void main() {

	// divide by w to get the correct value. See article on perspective
	vec3 projectedTexcoord = vProjectedTextureCoord.xyz / vProjectedTextureCoord.w;

	bool inRange = 
		projectedTexcoord.x >= 0.0 &&
		projectedTexcoord.x <= 1.0 &&
		projectedTexcoord.y >= 0.0 &&
		projectedTexcoord.y <= 1.0;

	vec4 projectedTexColor = texture2D(uProjectedTextureSampler, projectedTexcoord.xy);
	vec4 texColor = texture2D(uTextureSampler, vTextureCoord) * uColor;

	float projectedAmount = inRange ? 1.0 : 0.0;
	gl_FragColor = mix(texColor, projectedTexColor, projectedAmount);
}
`;

    private static vertexShaderSource = `
uniform mat4 uModelViewMatrix;
uniform mat4 uProjectionMatrix;

attribute vec3 aVertexPosition;
varying vec4 vPosition;

#ifdef SPI_ATTACHMENT
uniform mat4 uBoneMatrix;
uniform mat4 uOffsetMatrix;
#endif

#ifndef SPI_PICKING
attribute vec3 aVertexNormal;
uniform mat3 uNormalMatrix;
varying vec3 vTransformedNormal;
#endif

#ifdef SPI_ATTRIBUTE_COLOR
attribute vec4 aVertexColor;
varying vec4 vColor;
#endif

#ifdef SPI_ATTRIBUTE_LIGHT
attribute vec3 aVertexLight;
varying vec3 vVertexLight;
#endif

#ifdef SPI_TEXTURE
#ifndef SPI_PICKING
attribute vec2 aTextureCoord;
varying vec2 vTextureCoord;
uniform sampler2D uTextureSampler;
#endif
#endif

#ifdef SPI_ANIMATION
attribute vec4 aJointWeights;
attribute vec4 aJointIndices;

uniform mat4 uBindShapeMatrix;
uniform mat4 uInvBindShapeMatrix;
uniform sampler2D uMatrixSampler;
uniform vec3 uDataSettings;
#endif


#ifdef SPI_PRESET_COLOR
uniform vec4 uPresetColor;
#endif


#ifdef SPI_ANIMATION
mat4 read_matrix (sampler2D tex, float i, vec2 size) {
  // Apply an offset so that the coordinate targets the center of the texel, otherwise the wrong texel might be read causing incorrect matrices
  float offset = 0.5; 
  float tx = mod(i * 4.0, size.x) + offset;
  float ty = floor(i * 4.0 / size.x) + offset;
  
  return mat4(
    texture2D(tex, vec2((tx + 0.0) / size.x, ty / size.y)),
    texture2D(tex, vec2((tx + 1.0) / size.x, ty / size.y)),
    texture2D(tex, vec2((tx + 2.0) / size.x, ty / size.y)),
    texture2D(tex, vec2((tx + 3.0) / size.x, ty / size.y))
  );
}
#endif

void main(void) {
#ifdef SPI_ANIMATION
	vec4 skinVertex = vec4(aVertexPosition, 1.0) * uBindShapeMatrix;
	vec4 pos = vec4(0.0);
	#ifndef SPI_PICKING
	vec4 skinNormal = vec4(aVertexNormal, 0.0) * uBindShapeMatrix;
	vec4 normal = vec4(0.0);
	#endif
	for(int i = 0; i < 48; i++) { // TODO: Variable number of bones
		for(int j = 0; j < 4; j++) {
			if(int(aJointIndices[j]) == i) {
				
				float index = aJointIndices[j] + uDataSettings.z;
				mat4 jointMatrix = read_matrix(uMatrixSampler, index, uDataSettings.xy);
				pos += (skinVertex * jointMatrix) * aJointWeights[j]; 
				#ifndef SPI_PICKING
				normal += (skinNormal * jointMatrix) * aJointWeights[j];
				#endif
			}
		}
	}
#else
	vec4 pos = vec4(aVertexPosition, 1.0);
#ifndef SPI_PICKING
	vec4 normal = vec4(aVertexNormal, 0.0);
#endif
#endif

#ifdef SPI_ATTRIBUTE_COLOR
#ifdef SPI_PRESET_COLOR
	vColor = aVertexColor * uPresetColor;
#else
	vColor = aVertexColor;
#endif
#endif

#ifdef SPI_ATTRIBUTE_LIGHT
	vVertexLight = aVertexLight;
#endif

#ifdef SPI_ATTACHMENT
	pos = pos * uBoneMatrix;
#endif

	vPosition = uModelViewMatrix * vec4(pos.xyz, 1.0);
	gl_Position = uProjectionMatrix * vPosition;
#ifndef SPI_PICKING

#ifdef SPI_ATTACHMENT
	normal = normal * uBoneMatrix;
#endif
	vTransformedNormal = normalize(uNormalMatrix * normal.xyz);	
	
#ifdef SPI_TEXTURE
	vTextureCoord = aTextureCoord;
#endif
#endif
}
`;

    protected get warnAttributeMismatch(): boolean {
        return false;
    }
    constructor(gl: WebGLRenderingContext, settings: DecalShaderSettings) {
        super(gl, DecalShader.fragmentShaderSource, DecalShader.vertexShaderSource, settings);
    }

}
        